// John Eldhose 20190520
import { RestfulPost } from './Restful';

export async function getProducts(pid) {
  const prods = await RestfulPost('getProducts', {pid: pid}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return prods;
}



// WEBPACK FOOTER //
// ./src/Api/getProducts.js